import React from "react";
import { Row, Col, Typography, Spin, Card, Image } from "antd";

const { Title } = Typography;
export default function Opened({data,loading}) {
  return (
    <div>
    <Spin spinning={loading} size="large">
      <Row>
        {data.map((item, index) => (
          <Col key={index} span={8}>
            <Card
              className="product-card-analytics"
              cover={
                <Image
                  // src={`${process.env.REACT_APP_CLOUDINARY}/b_rgb:f2f2f2,c_pad,h_140,q_70,w_177/${item?.products_id?.product_images?.[0]?.directus_files_id}`}
                  src={`${process.env.REACT_APP_DIRECTUS}assets/${item?.products_id?.product_images?.[0]?.directus_files_id}?transforms=[["resize",{"width":177,"height":140,"fit":"contain","background":{"r":242,"g":242,"b":242}}]]`}
                  alt={"product name"}
                  preview={false}
                />
              }
             
            >
             
              <Row>
                <Title className="product-id" type="secondary" level={5}>
                  ID :{" "}
                  {item?.products_id?.product_id
                    ? item?.products_id?.product_id
                    : "No product id"}
                </Title>
              </Row>
            </Card>
          </Col>
        ))}
      </Row>
    </Spin>
  </div>
  );
}
